import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {CampaignForm} from '@app/@core/advertising/campaign/campaign-form';
import {CampaignDraft} from "@app/@core/advertising/campaign/campaign-draft";
import {ConfigService} from "@app/@core/@config/config.service";
import {CheckedComponentInternal} from "@app/campaigns/campaign/@common/campaign-drafting/checked-component-internal";
import {SignedInContextService} from "@app/@shells/signed-in-shell/signed-in-context.service";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-campaign-billing-email[campaignForm]',
  templateUrl: './campaign-billing-email.component.html',
  styleUrls: ['./campaign-billing-email.component.scss']
})
export class CampaignBillingEmailComponent implements OnInit, OnChanges {
  @Input() campaignForm!: FormGroup;
  checked: CheckedComponentInternal;

  constructor(private signedInContextService: SignedInContextService) {
    this.checked = new CheckedComponentInternal('billingEmail');
  }

  ngOnInit(): void {
    this.applyComponentLogic();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['campaignForm'] && this.campaignForm) {
      this.applyComponentLogic();
    }
  }

  private applyComponentLogic(): void {
    const billingNameValue = this.campaignForm.get('billingEmail')?.value;
    this.checked.init(this.campaignForm);
    if (!billingNameValue) {
      this.signedInContextService.context$().subscribe(context => {
        this.checked?.initChecked(context.user.username);
      });
    }
  }

  checkboxClicked(): void {
    this.checked?.checkboxClicked();
  }
}
